import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-1-small', 'IconNumber1Small', [["path",{"d":"M11 8h1v8","key":"svg-0"}]]);